export interface Currency {
  amount: number;
  currency: string;
  minor: number;
}

export enum CouponType {
  PRECENTAGE = 'percentage',
  FIXED_AMOUNT = 'fixed',
}

export interface Coupon {
  code: string;
  type: CouponType;
  value: number;
  amount?: Currency;
  active: boolean;
  paymentMethod?: string;
  expiresAt: string | null;
}

export interface PaymentMethod {
  slug: string;
  enable: number | boolean;
  platforms: {
    web: boolean;
  };
}

export enum CreditCardBrand {
  AMERICAN_EXPRESS = 'American Express',
  MASTERCARD = 'MasterCard',
  VISA = 'Visa',
}

export interface CreditCard {
  brand: CreditCardBrand;
  last4: string;
}

export enum PaymentStatus {
  WAITING = 'WAITING',
  REFUND = 'REFUND',
  HOLDING = 'HOLDING',
  PENDING = 'PENDING',
  PAID = 'PAID',
}
